import { supportsFetch } from '@sentry/utils'
import type { BrowserClientOptions } from '@sentry/browser/types/client'
import {
  makeFetchTransport,
  defaultStackParser,
  defaultIntegrations,
  makeXHRTransport,
  BrowserTracing,
} from '@sentry/browser'
import { LocalStorage } from './utils/constants'

export const initialSentryOpts: BrowserClientOptions = {
  integrations: [...defaultIntegrations, new BrowserTracing()],
  tracesSampleRate: 1.0,
  autoSessionTracking: true,
  maxBreadcrumbs: 80,
  transport: supportsFetch() ? makeFetchTransport : makeXHRTransport,
  stackParser: defaultStackParser,
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'console' ? null : breadcrumb
  },
  initialScope: (scope) => {
    scope.setUser({ email: localStorage.getItem(LocalStorage.EMAIL) })
    return scope
  },
}
